let counter = 0

export const addBmTelemetryToHeaders = async (
  reqHeaders
) => {
  const { bmak } = window || {}

  if (!bmak && counter < 5) {
    counter += 1
    return addBmTelemetryToHeaders(reqHeaders)
  }

  const updatedHeaders = { ...reqHeaders }
  return {
    ...updatedHeaders,
    headers: {
      ...updatedHeaders.headers,
      'BM-Telemetry': bmak && bmak.get_telemetry()
    }
  }
}

export default addBmTelemetryToHeaders
